var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "结算记录详情",
        visible: _vm.visible,
        footer: null,
        width: "900px",
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-descriptions",
        { attrs: { column: 2, bordered: "" } },
        [
          _c("a-descriptions-item", { attrs: { label: "结算订单ID" } }, [
            _vm._v(" " + _vm._s(_vm.detailData.settlementNo) + " "),
          ]),
          _c("a-descriptions-item", { attrs: { label: "结算日期" } }, [
            _vm._v(
              " " + _vm._s(_vm.formateDate(_vm.detailData.settlementDate)) + " "
            ),
          ]),
          _c("a-descriptions-item", { attrs: { label: "结算金额" } }, [
            _c(
              "span",
              { staticStyle: { color: "#1890ff", "font-weight": "bold" } },
              [
                _vm._v(
                  _vm._s(_vm.formatAmount(_vm.detailData.settlementAmount, "¥"))
                ),
              ]
            ),
          ]),
          _c("a-descriptions-item", { attrs: { label: "打款金额" } }, [
            _c(
              "span",
              { staticStyle: { color: "#52c41a", "font-weight": "bold" } },
              [_vm._v(_vm._s(_vm.formatAmount(_vm.detailData.amountPaid, "¥")))]
            ),
          ]),
          _c("a-descriptions-item", { attrs: { label: "手续费" } }, [
            _c(
              "span",
              { staticStyle: { color: "#fa8c16", "font-weight": "bold" } },
              [_vm._v(_vm._s(_vm.formatAmount(_vm.detailData.fee, "¥")))]
            ),
          ]),
          _c(
            "a-descriptions-item",
            { attrs: { label: "账户类型" } },
            [
              _c(
                "a-tag",
                {
                  attrs: {
                    color: _vm.getAccountTypeColor(_vm.detailData.accountType),
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.getAccountTypeText(_vm.detailData.accountType)
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("a-descriptions-item", { attrs: { label: "银行名称" } }, [
            _vm._v(" " + _vm._s(_vm.detailData.bankName) + " "),
          ]),
          _c("a-descriptions-item", { attrs: { label: "银行代码IFSC" } }, [
            _vm._v(" " + _vm._s(_vm.detailData.ifscCode) + " "),
          ]),
          _c("a-descriptions-item", { attrs: { label: "账户名" } }, [
            _vm._v(" " + _vm._s(_vm.detailData.accountName) + " "),
          ]),
          _c("a-descriptions-item", { attrs: { label: "账户号" } }, [
            _vm._v(" " + _vm._s(_vm.detailData.accountName) + " "),
          ]),
          _c(
            "a-descriptions-item",
            { attrs: { label: "结算状态" } },
            [
              _c(
                "a-tag",
                { attrs: { color: _vm.getStatusColor(_vm.detailData.status) } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.getStatusText(_vm.detailData.status)) + " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("a-descriptions-item", { attrs: { label: "创建时间", span: 2 } }, [
            _vm._v(
              " " + _vm._s(_vm.formateDate(_vm.detailData.createdAt)) + " "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }